import { Component } from '@angular/core'
import { ShellService } from 'src/app/services/shell.service'

/** Hosted once in app.component.html; the blocking "Please wait" box while ShellService.busyWhile() runs. */
@Component({
  selector: 'rt-loading',
  template: `
    <div *ngIf="shell.busy$ | async as b" class="rt-loading" role="alert" aria-busy="true">
      <div class="rt-loading__box">
        <img class="rt-loading__mark" src="assets/brand/swirl.png" alt="" />
        <b>Please wait</b>
        <span *ngIf="b.message">{{ b.message }}</span>
      </div>
    </div>`,
})
export class RtLoadingComponent {
  constructor(readonly shell: ShellService) {}
}
